import FidsPage from "./FidsPage";

export default function FidsT1Page() {
  return (
    <FidsPage
      terminal="MTB"
      terminalName="KUL — KLIA Terminal 1 (Main Terminal Building)"
      terminalLabel="FIDS T1"
    />
  );
}
